import React from 'react';
import calculateLuminance from '../../../shared/utils/color/calculateLuminance';
import hexToRgb from '../../../shared/utils/color/hexToRgb';
import Div from '../../Element/Div/Div';
import Flex from '../../Flex/Flex';
import SmallText from '../../Typography/SmallText/SmallText';
import styles from './CardColorVariants.module.scss';

const borderThreshold = calculateLuminance(hexToRgb('#eeeeee'));

const VariantDot: React.FC<{ color: string }> = ({ color }) => {
  const rgbColor = hexToRgb(color);
  const showBorder = calculateLuminance(rgbColor) >= borderThreshold;

  return (
    <Div
      className={[
        styles.cardColorVariants_dot,
        { [styles.cardColorVariants_dot__withBorder]: showBorder },
      ]}
      style={{ backgroundColor: color }}
    />
  );
};

export type CardColorVariantsProps = {
  /** Product variant colors as hex, #ffffff */
  colorVariants: string[];
};

const CardColorVariants: React.FC<CardColorVariantsProps> = ({
  colorVariants,
}) => {
  const hasMany = colorVariants.length > 4;
  const visibleVariants = hasMany ? colorVariants.slice(0, 3) : colorVariants;
  const hiddenVariantCount = colorVariants.length - visibleVariants.length;

  return (
    <Div>
      <Flex centeredVertically className={styles.cardColorVariants_container}>
        {visibleVariants.map((colorVariant, i) => (
          <VariantDot key={i} color={colorVariant} />
        ))}

        {hasMany && (
          <SmallText color="gray500" size="sm">
            +{hiddenVariantCount}
          </SmallText>
        )}
      </Flex>
    </Div>
  );
};

export default CardColorVariants;
